import PropTypes from 'prop-types'
import React from 'react'
import { Waypoint } from 'react-waypoint'
import User from 'components/ControlledUser'
import Loader from 'components/Loader'

export class UserGroupUsers extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    keyword: PropTypes.string,
    userComponent: PropTypes.func.isRequired,

    userGroup: PropTypes.object,

    fetchUserGroupUsers: PropTypes.func.isRequired,
  }

  static defaultProps = {
    userComponent: User
  }

  constructor (props) {
    super(props)

    this.fetchUsers = this.fetchUsers.bind(this)
  }

  componentDidMount () {
    this.fetchUsers({ refresh: true })
  }

  componentDidUpdate (prevProps) {
    if (this.props.keyword !== prevProps.keyword) {
      this.fetchUsers({ refresh: true })
    }
  }

  fetchUsers (args) {
    const { id, keyword, userGroup, fetchUserGroupUsers } = this.props

    fetchUserGroupUsers({
      id,
      keyword,
      cursor: userGroup.usersCursor,
      ...args
    })
  }

  render () {
    const {
      id,
      keyword,
      userComponent: UserComponent,

      userGroup,

      fetchUserGroupUsers, // eslint-disable-line no-unused-vars

      ...props
    } = this.props

    return (
      <div {...props}>
        {userGroup.users.map(id =>
          <UserComponent
            key={id}
            id={id}
            listItem
            defaultMenu
            presence
          />
        )}
        {userGroup.usersLoading &&
          <Loader center />
        }
        {(!userGroup.usersLoaded && !userGroup.usersLoading) &&
          <Waypoint
            key={userGroup.usersCursor}
            onEnter={() => this.fetchUsers()}
            bottomOffset='-50%'
          />
        }
      </div>
    )
  }
}

export default UserGroupUsers
